import { render, staticRenderFns } from "./ModuleImportDlg.vue?vue&type=template&id=4c82f033&scoped=true&"
import script from "./ModuleImportDlg.vue?vue&type=script&lang=ts&"
export * from "./ModuleImportDlg.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleImportDlg.vue?vue&type=style&index=0&id=4c82f033&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82f033",
  null
  
)

export default component.exports